export default {
  INIT: 'ORDER/INIT',
  UPDATE_DATA: 'ORDER/UPDATE_DATA',
  UPDATE_META: 'ORDER/UPDATE_META',
  UPDATE_PARAMS: 'ORDER/UPDATE_PARAMS',
  RESET_DATA: 'ORDER/RESET_DATA',
  UPDATE_PENDING_ALERT_SOUND_TOGGLE: 'ORDER/UPDATE_PENDING_ALERT_SOUND_TOGGLE',
}
